import "./Button.css";

export const Button = ({ children, onClick, href, variant = "primary" }) => {
  const className = `cta-button cta-button--${variant}`;

  if (href) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={className}>
      {children}
    </button>
  );
};
